import React , {Component} from 'react'
import {Row,Col,Container} from 'reactstrap'
import SavedImages from './SavedImages'
import './SavedImages.css'
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import * as actionCreators from '../../../Actions/Index';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

class Saved extends Component{

constructor(){

   super();
   this.state = {
    products: [
        { title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/DSC_2484_-_Copy.JPG?v=1553906693" , price: "1290",saveCount: 82},
        { title : 'Khaadi', image: "https://www.khaadi.com/media/catalog/product/cache/8311afee373c39545ab7d755459cdad7/w/t/wtpe19208b_ltblue_1_.jpg", price: "1290",saveCount: 80},
        { title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0707-SSH-BLU_1.jpg?v=1552043754", price: "1290",saveCount: 82},
        { title : 'Limelight', image: "https://d224nth7ac0evy.cloudfront.net/catalog/product/cache/926507dc7f93631a094422215b778fe0/i/p/ipw-18-62-_3_.jpg", price: "1290",saveCount: 82},
        { title : 'Limelight', image: "https://www.junaidjamshed.com/media/catalog/product/cache/image/e9c3970ab036de70892d86c6d221abfe/j/j/jjpw-a-jps-203-1.jpg", price: "1290",saveCount: 82},
        {title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0387-SSH-PNK_1.jpg?v=1551876015", price: "1290",saveCount: 82},
    ],
    savedItem:[],
    showItems:0
   }
}
isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight+200;
  }
    componentWillMount(){
      document.addEventListener('scroll', this.trackScrolling);
      var userID = cookies.get("usfid");

      this.unlisten = this.props.history.listen((location, action) => {
          this.props.getSavedProductsByUserID(userID);
      this.setState({savedItem:this.props.savedItem});
      });

      this.props.getSavedProductsByUserID(userID);
      this.setState({savedItem:this.props.savedItem});
    
    
    }
    componentWillUnmount() {
      document.removeEventListener('scroll', this.trackScrolling);
    }
  
    componentWillReceiveProps(nextProps){
      this.setState({savedItem:nextProps.savedItem});
  }
  trackScrolling = () => {
    const wrappedElement = document.getElementById('root');
    if (this.isBottom(wrappedElement)) {
      
      //this.handleShowMore();
    }
  };
  handleShowMore() {
    this.setState({
      showItems: 
        this.state.showItems >= this.state.savedItem?.length ?
          this.state.showItems : this.state.showItems + 20
    })
  }

render(){
    return (
                <ol className="saved-items">
                {/* {this.state.savedItem.map(item=>{ */}
                    {/* return( */}
                 <SavedImages image={'//cdn.shopify.com/s/files/1/2635/3244/products/U0668_Rust_copy.jpg?v=1558598495'} productID={'34'}></SavedImages>
                    {/* )} */}
                    {/* )} */}
                </ol>
        )}
}
const mapStateToProps=(state)=>(

    {
        savedItem:state.savedItem,
 
  });
  
  const mapDispatchToProps = dispatch => {
     var uid = cookies.get("usfid")
    return {
        getSavedProductsByUserID: (uid) => dispatch(actionCreators.getSavedProductsByUserID(uid)),
    }
    
  }

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Saved));